// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
export class AC extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'Acceleration Oscillator';
        this.Comments = 'Acceleration Oscillator';
        super.SetIndicatorLine('asc', Color.Green, 1, LineStyle.HistogrammChart);
        super.SetIndicatorLine('desc', Color.Red, 1, LineStyle.HistogrammChart);
        this.SeparateWindow = true;
    }
    Init() {
        super.Init();
        super.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'AC';
    }
    createInternalIndicators() {
        this.ac = this.Indicators.iAC(this.CurrentData);
        super.IndicatorShortName(this.GetIndicatorShortName());
        return [this.ac];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count >= 39) {
            const curr = this.ac.GetValue();
            const prev = this.ac.GetValue(1);
            if (prev < curr) {
                super.SetValue(0, curr);
                super.SetValue(1, 0);
            }
            else if (prev > curr) {
                super.SetValue(0, 0);
                super.SetValue(1, curr);
            }
            else {
                super.SetValue(0, 0);
                super.SetValue(1, 0);
            }
        }
    }
}
